// extracted by mini-css-extract-plugin
export var firstview = "firstview-module--firstview--aad51";
export var firstview_contents = "firstview-module--firstview_contents--e4cc8";
export var firstview_h2 = "firstview-module--firstview_h2--c86e8";